import * as React from 'react';
import { compose, setDisplayName, withProps } from 'recompose';
import { translate } from 'react-i18next';
import { TranslateProps } from 'util/i18n';
import { skin, OemProps } from 'ui/styles/skin';
import { WarningTriangle } from 'ui/shapes';

export type OwnProps = {
    text?: string | null;
    textKey?: string;
    style?: object;
    size?: string;
};

export const RawErrorMessage = ({ text, textKey = '', t, size = '1em', styles }: OwnProps & TranslateProps & OemProps) =>
    <span
        className="error-message"
        style={ styles.container }
    >
        <WarningTriangle
            width={ size }
            height={ size }
            style={ styles.symbol }
        />
        <span
            style={ styles.message }
        >
            { text || t(textKey) }
        </span>
    </span>
;

export const ErrorMessage = compose<OwnProps & TranslateProps & OemProps, OwnProps>(
    setDisplayName('ErrorMessage'),
    skin,
    translate(),
    withProps(({ style, styles }: OwnProps & OemProps) => ({
        styles: {
            ...styles,
            container: {
                ...styles.Error,
                ...style,
                textShadow: '1px 1px 1px rgba(0,0,0,.5)',
            },
            symbol: {
                fill: styles.Error.color,
                verticalAlign: 'middle',
            },
            message: {
                marginLeft: '.5em',
                verticalAlign: 'middle',
            },
        },
    })),
)(RawErrorMessage);



// WEBPACK FOOTER //
// ./src/ui/shared/ErrorMessage.tsx